import { render, staticRenderFns } from "./top-section.vue?vue&type=template&id=0a289d97&scoped=true&"
import script from "./top-section.vue?vue&type=script&lang=ts&"
export * from "./top-section.vue?vue&type=script&lang=ts&"
import style0 from "./top-section.vue?vue&type=style&index=0&id=0a289d97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a289d97",
  null
  
)

export default component.exports